
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^1(215|972)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
